<template>
  <div class="g-content">
    <div class="page-exhibits">
      <!-- 操作 -->
      <div class="btns-warap clearfix">
        <div class="left">
          <div class="fl">
            <el-button class="el-primary-border" @click="addCollect">
              <svg-icon icon-class="add" class-name="icon-add" />&nbsp;添加藏品
            </el-button>

            <el-button class="el-primary-border" @click="addOtherCollect">
              <svg-icon icon-class="add" class-name="icon-add" />&nbsp;添加馆外藏品
            </el-button>
            <!-- <el-button class="el-primary-border" @click="importCollect">
              <svg-icon icon-class="daoru"/>&nbsp;从收藏夹导入
            </el-button> -->
            <el-button class="el-primary-border" @click="exportItem">
              <svg-icon icon-class="daochu" />&nbsp;导出
            </el-button>
            <el-button class="el-primary-border" @click="dele">
              <i class="el-icon-close"></i>&nbsp;移除
            </el-button>
            <el-button class="el-primary-border" v-if="!showSearch" @click="showSearch=true">
              <i class="el-icon-search"></i>&nbsp;搜索
            </el-button>
          </div>

          <div class="fl">
            <!-- <el-input class="input-block ml-20" suffix-icon="el-icon-search" -->
            <el-input class="ml-20" style="width:300px;" placeholder="输入藏品名称进行搜索" @keyup.enter.native="getDataList" v-if="showSearch" v-model="listQuery.key">
              <i slot="suffix" class="el-icon-search g-pointer" @click="getDataList"></i>
            </el-input>
          </div>
        </div>
      </div>

      <!-- 列表 -->
      <el-table ref="multipleTable" v-loading="listLoading" :data="dataList" :row-key="(row)=>{ return row.exhibitsId}" @selection-change="handleSelectionChange" element-loading-text="Loading" stripe highlight-current-row>
        <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
        <el-table-column label="序号" width="70">
          <template slot-scope="scope">{{ scope.$index+1 }}</template>
        </el-table-column>

        <el-table-column label="藏品图片" width="120">
          <template slot-scope="scope">
            <viewer :options="{ url: 'data-maxUrl' }">
              <img class="g-pointer" :src="scope.row.imgUrl || ''" :data-maxUrl="scope.row.imgUrl" alt :onerror="defaultImg" style="width: 36px;">
            </viewer>
          </template>
        </el-table-column>
        <!-- <el-table-column v-for="(item, index) in titleList" :label="item.name">
          <template slot-scope="scope">
            {{ scope.row.title }}
          </template>
        </el-table-column>-->
        <el-table-column label="藏品名称" width="400">
          <template slot-scope="scope">
            <a class="m-btn" @click="getDetail(scope.row)">{{ scope.row.collectName | ellSplit(38) }}</a>
          </template>
        </el-table-column>

        <el-table-column label="总登记号" width="150">
          <template slot-scope="scope">{{ scope.row.signCode }}</template>
        </el-table-column>

        <el-table-column label="分类号" width="150">
          <template slot-scope="scope">{{ scope.row.typeCode }}</template>
        </el-table-column>

        <el-table-column label="年代" width="500">
          <template slot-scope="scope">{{ scope.row.collectYear }}</template>
        </el-table-column>
        <el-table-column class-name="status-col" label="尺寸" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.detailSize }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column label="质地" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.collectTexture }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="created_at" label="具体质量">
          <template slot-scope="scope">{{ scope.row.detailQuality }}</template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>

      <cmp-collect-add ref="addCollectDialog" @addCall="getDataList"></cmp-collect-add>
      <cmp-collect-import ref="importCollectDialog" @importCall="getDataList"></cmp-collect-import>
      <add-collect ref="addCollect"  @addCall="getDataList"></add-collect>

      <!-- <cmp-footer></cmp-footer> -->
    </div>
  </div>
</template>

<script>
// 跨页选择参考 https://segmentfault.com/a/1190000019263783?utm_source=tag-newest
// import cmpFooter from '@cmp/footer'
import cmpCollectAdd from './dialog/dialog-collect-add'
import cmpCollectImport from './dialog/dialog-collect-import'
import addCollect from './dialog/dialog-add-collect'

export default {
  components: {
    // cmpFooter,
    cmpCollectAdd,
    cmpCollectImport,
    addCollect
  },
  data() {
    return {
      defaultImg: this.$store.state.app.defaultImg,
      showSearch: false,
      dataList: [],
      total: 0,
      listLoading: true,
      listQuery: {
        key: '',
        currentPage: 1,
        size: 10
      },
      // titleList: [
      //   {
      //     name: '分类号'
      //   },
      //   {
      //     name: '藏品名称'
      //   },
      //   {
      //     name: '质地'
      //   },
      //   {
      //     name: '年代'
      //   },
      //   {
      //     name: '尺寸'
      //   },
      //   {
      //     name: '具体质量'
      //   },
      // ],
      multipleSelection: []
    }
  },
  methods: {
    addCollect() {
      this.$refs.addCollectDialog.init()
    },

    addOtherCollect() {
      this.$refs.addCollect.init('add')
    },

    getDetail(obj) {
      this.$refs['addCollect'].init('detail', obj.collectId)
      // this.$http
      //       .get('exhibits/getDetail', {
      //         collectId: obj.collectId,
      //         projectId: this.$route.query.projectId
      //       })
      //       .then(res => {
      //         if (res.success) {
      //           console.log(res)
      //         } else {
      //           this.$message.error(res.message)
      //         }
      //       })
    },
    // 导入藏品
    importCollect() {
      this.$refs.importCollectDialog.init()
    },
    // 导出
    exportItem() {
      if (!this.multipleSelection.length) {
        this.$message({
          message: '请选择藏品',
          type: 'warning'
        })
        return
      }
      let arr = []
      this.multipleSelection.forEach(item => {
        arr.push(item.exhibitsId)
      })
      location.href = '/singleMuseum/exhibits/batchExport?arr=' + arr.join(',')
    },
    // 移除
    dele() {
      if (!this.multipleSelection.length) {
        this.$message({
          message: '请选择藏品',
          type: 'warning'
        })
        return
      }
      let arr = []
      this.multipleSelection.forEach(item => {
        arr.push(item.exhibitsId)
      })

      this.$common.confirm(
        {
          title: '移除藏品',
          content: '是否确认移除藏品'
        },
        () => {
          this.$http
            .post('/exhibits/batchDeletePublicCollect', {
              exhibitsIds: arr
            })
            .then(res => {
              if (res.success) {
                this.$message.success('移除成功')
                this.$refs.multipleTable.clearSelection()
                this.getDataList('dele')
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },
    // 勾选复选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    getDataList(type) {
      this.listLoading = true
      this.$http
        .get('/exhibits/getExhibitsList', {
          ...this.listQuery,
          projectId: this.$route.query.projectId
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            // 是否为删除操作
            if (
              type === 'dele' &&
              this.listQuery.currentPage > 1 &&
              !res.result.length
            ) {
              this.listQuery.currentPage -= 1
              this.getDataList()
              return
            }
            this.dataList = res.result
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getDataList()
    },
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getDataList()
    }
  },
  created() {
    this.getDataList()
  }
}
</script>

<style lang="scss" scoped>
.btns-warap {
  margin-bottom: 20px;
  .btn-view {
    line-height: 40px;
  }
}
</style>


